"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stencilStylesForPrimitives = exports.getAriaLabelProps = exports.ToolbarButton = exports.StyledPopoverOptionSeparator = exports.StyledPopoverList = exports.StyledPopoverItem = exports.StyledPopoverColorOptionTextContainer = exports.StyledPopoverColorOptionContainer = exports.StyledHighlightBadge = exports.StyledColorItem = exports.StyledBadge = exports.StatusContainer = exports.EditorWrapper = exports.EditorContentBackground = exports.EditorContainer = exports.EditorBorderedContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _constants = require("../button/constants");

var _button = require("../button");

var _context = require("../context");

var _layout = require("../layout");

var _link = require("../link");

var _text = require("../text");

var _utils = require("../utils");

var _constants2 = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getAriaLabelProps = function getAriaLabelProps(ariaLabel, ariaLabelledBy) {
  var values = {};

  if (ariaLabelledBy) {
    values['aria-labelledby'] = ariaLabelledBy;
  } else {
    values['aria-label'] = ariaLabel;
  }

  return values;
};

exports.getAriaLabelProps = getAriaLabelProps;
var EditorWrapper = (0, _context.styledWithTheme)(_layout.Col)(function (_ref) {
  var selectors = _ref.theme.selectors,
      isFullScreen = _ref.isFullScreen,
      disabled = _ref.disabled;
  var backgroundColor = selectors.color(disabled ? 'neutral10' : 'neutral0');
  return isFullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: selectors.zIndex('header') || 0,
    backgroundColor: backgroundColor,
    height: '100vh',
    maxHeight: 'initial',
    width: '100vw'
  } : {
    width: '100%',
    backgroundColor: backgroundColor
  };
});
exports.EditorWrapper = EditorWrapper;
var EditorBorderedContainer = (0, _context.styledWithTheme)(_layout.Col)(function (_ref2) {
  var theme = _ref2.theme,
      minHeight = _ref2.minHeight,
      maxHeight = _ref2.maxHeight,
      isFullScreen = _ref2.isFullScreen;
  return {
    position: 'relative',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.selectors.color('neutral50'),
    borderRadius: isFullScreen ? 0 : theme.selectors.radius('R300'),
    minHeight: isFullScreen ? 0 : minHeight,
    maxHeight: isFullScreen ? '100%' : maxHeight,
    flexGrow: 1
  };
});
exports.EditorBorderedContainer = EditorBorderedContainer;
var Blockquote = (0, _context.styledWithTheme)('blockquote')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontFamily: theme.selectors.fontFamily('primary'),
    margin: 24,
    paddingLeft: 16,
    position: 'relative',
    p: {
      margin: 0
    },
    ':before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      width: 4,
      height: '100%',
      borderRadius: theme.selectors.radius('R100'),
      backgroundColor: theme.selectors.color('primary50')
    }
  };
});

var stencilStylesForPrimitives = function stencilStylesForPrimitives(props) {
  return "\na {\n  ".concat((0, _utils.extractCSSFromComponent)(_link.LinkBase, props), "\n}\nblockquote {\n  ").concat((0, _utils.extractCSSFromComponent)(Blockquote, props), "\n}\ncode {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.Code, props), "\n}\nh1 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H1, props, 'font-weight: bold;'), "\n}\nh2 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H2, props, 'font-weight: bold;'), "\n}\nh3 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H3, props, 'font-weight: bold;'), "\n}\nh4 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H4, props, 'font-weight: bold;'), "\n}\nh5 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H5, props, 'font-weight: bold;'), "\n}\nh6 {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.H6, props, 'font-weight: bold;'), "\n}\nhr {\n  ").concat((0, _utils.extractCSSFromComponent)(_layout.Hr, props), "\n  }\np {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.P, props), "\n}\nli,li::marker,p.is-editor-empty:first-of-type::before {\n  ").concat((0, _utils.extractCSSFromComponent)(_text.P, props), "\n}\nul { list-style: disc; }\nol { list-style-type: decimal; }\nimg {\n  max-width: 100%;\n  cursor: pointer;\n\n  &.ProseMirror-selectednode {\n    outline: 2px solid ").concat(props.theme.selectors.color('primary70'), ";\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n}\ntable {\n  border-collapse: collapse;\n  table-layout: auto;\n  border-spacing: 0;\n  width: 100%;\n  margin: 0;\n  overflow: hidden;\n\n  td,\n  th {\n    min-width: 1em;\n    border: 1px solid ").concat(props.theme.selectors.color(_constants2.TABLE_BORDER_COLOR), ";\n    vertical-align: middle;\n    box-sizing: border-box;\n    position: relative;\n    padding: 8px 16px;\n    text-align: left;\n    > * {\n      align-items: center; \n      margin-top: 8px; \n      margin-bottom: 8px;\n    }\n  }\n\n  thead, tbody {\n    vertical-align: middle;\n  }\n  \n  td, th, tr {\n    vertical-align: inherit;\n  }\n\n  th {\n    background-color: ").concat(props.theme.selectors.color(_constants2.TABLE_HEADER_BACKGROUND_COLOR), ";\n  }\n");
}; // Highlight color is a system-color in browsers.
// It is the color that browsers use for selection style.
// https://developer.mozilla.org/en-US/docs/Web/CSS/system-color


exports.stencilStylesForPrimitives = stencilStylesForPrimitives;

var selectionStyle = function selectionStyle(props) {
  return "\nmark {\n  background-color: Highlight;\n  box-shadow: 0px 3px 0px Highlight, 0px -3px 0px Highlight;\n}\n\n&:focus mark {\n  background-color: none;\n  box-shadow: none;\n}\n\np > mark {\n  ".concat((0, _utils.extractCSSFromComponent)(_text.P, props), "\n}\n\na > mark {\n  ").concat((0, _utils.extractCSSFromComponent)(_link.LinkBase, props), "\n}\n\n// Underline color matches the text color appplied to the selection \na > span.ProseMirror-FontColor {\n  text-decoration: underline;\n  text-decoration-color: inherit;\n}\n\na:hover > span.ProseMirror-FontColor {\n  text-decoration: none;\n  text-decoration-color: none;\n}\n");
};

function getFocusStyle(border, radius, hasToolbar, hasWordCounter) {
  var borderRadiusStyle = {};

  if (!hasToolbar) {
    borderRadiusStyle['border-top-left-radius'] = radius;
    borderRadiusStyle['border-top-right-radius'] = radius;
  }

  if (!hasWordCounter) {
    borderRadiusStyle['border-bottom-left-radius'] = radius;
    borderRadiusStyle['border-bottom-right-radius'] = radius;
  }

  var borderRadiusStyleCSS = Object.entries(borderRadiusStyle).map(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
        prop = _ref5[0],
        value = _ref5[1];

    return "".concat(prop, ": ").concat(value, ";");
  }).join('\n');
  return "\n    outline: ".concat(border, ";\n    outline-offset: -").concat(_constants2.OUTLINE_WIDTH, "px;\n    ").concat(borderRadiusStyleCSS, ";\n  ");
}

var EditorContainer = (0, _context.styledWithTheme)(_layout.Container)(function (_ref6) {
  var theme = _ref6.theme,
      isSmallScreen = _ref6.isSmallScreen,
      isFocused = _ref6.isFocused,
      disabled = _ref6.disabled,
      hasToolbar = _ref6.hasToolbar,
      hasWordCounter = _ref6.hasWordCounter,
      isFullScreen = _ref6.isFullScreen;
  return "\n  ".concat(disabled ? 'cursor: not-allowed;' : '', "\n\n  ").concat(getFocusStyle("".concat(isFocused ? _constants2.OUTLINE_WIDTH : 0, "px solid ").concat(theme.selectors.color('primary80')), isFullScreen ? 0 : (0, _utils.px)(theme.selectors.radius('R200')), hasToolbar, hasWordCounter), "\n  \n  height: 100%;\n  overflow: auto;\n  position: relative;\n  z-index: 0;\n  flex-grow: 1;\n\n  & > [data-test-component=\"StencilReactContainer\"] > div {\n    min-height: 100%;\n  }\n\n  .ProseMirror {\n    z-index: 1;\n\n    * {\n      box-sizing: border-box;\n    }\n\n    outline: none;\n    white-space: pre-wrap;\n    padding: ").concat(isSmallScreen ? 16 : 32, "px;\n    height: 100%;\n\n    p.is-editor-empty:first-of-type::before {\n      color: ").concat(theme.selectors.color('neutral50'), ";\n      content: attr(data-placeholder);\n      pointer-events: none;\n      position: absolute;\n    }\n\n    ").concat(selectionStyle({
    theme: theme
  }), "\n    table { \n      table-layout: fixed; \n    } \n  }\n\n  // The table-related classes below were automatically added by the Tiptap extension.\n    \n    @media screen and (forced-colors: active) {\n      th {\n        border-right: 2px solid;\n        border-bottom: 2px solid;\n      }\n      td {\n        border-right: 1px solid; \n        border-bottom: 1px solid;\n      }\n      tr:last-child th {\n        border-left: 2px solid;\n      }\n      tr:first-of-type th {\n        border-top: 2px solid;\n      }\n      tbody > tr:first-of-type  > th:last-child {\n        border-right: 2px solid;\n      }\n      tr:first-of-type th:first-of-type {\n        border-left: 2px solid;\n      }\n      tr:not(:first-of-type) th:first-of-type { \n        border-left: 2px solid\n      }\n      tr:last-child th:first-of-type {\n        border-left: 2px solid;\n        border-bottom: 2px solid;\n      }\n    }\n    .selectedCell:after {\n      z-index: 2;\n      position: absolute;\n      content: \"\";\n      left: 0; right: 0; top: 0; bottom: 0;\n      background: ").concat((0, _utils.opacify)(theme.selectors.color(_constants2.TABLE_SELECTED_CELL_BACKGROUND_COLOR), 0.45), ";\n      pointer-events: none;\n    }\n\n    .column-resize-handle {\n      position: absolute;\n      right: -2px;\n      top: 0;\n      bottom: -2px;\n      width: 1px;\n      background-color: #adf;\n      pointer-events: none;\n    }\n  }\n\n  .resize-cursor {\n    cursor: ew-resize;\n    cursor: col-resize;\n  }\n  \n  ").concat(stencilStylesForPrimitives({
    theme: theme
  }), "\n}");
});
exports.EditorContainer = EditorContainer;
var EditorContentBackground = (0, _context.styledWithTheme)('div')({
  position: 'absolute',
  zIndex: -1,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
});
exports.EditorContentBackground = EditorContentBackground;
var StatusContainer = (0, _context.styledWithTheme)(_layout.Row)(function (_ref7) {
  var isSmallScreen = _ref7.isSmallScreen;
  return {
    width: '100%',
    padding: isSmallScreen ? '8px' : '8px 24px',
    justifyContent: 'flex-end',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0, rgba(255,255,255,1) 100%)',
    marginTop: -38,
    zIndex: 10
  };
});
exports.StatusContainer = StatusContainer;
var ToolbarButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref8) {
  var selectors = _ref8.theme.selectors;
  var color = selectors.color('neutral90');
  var outlineStyle = (0, _utils.addOutline)(_constants.BORDER_WIDTH, _constants.OUTLINE_OFFSET, color, undefined, undefined, {
    backgroundColor: 'transparent',
    borderColor: color
  });
  return _objectSpread(_objectSpread({
    color: color,
    borderWidth: 0
  }, outlineStyle.rest), {}, {
    '&[data-active="true"]': {
      borderWidth: 2,
      ':hover': {
        outlineColor: color,
        outlineOffset: 2
      }
    },
    ':hover': outlineStyle.focus,
    ':focus': outlineStyle.focus
  });
});
exports.ToolbarButton = ToolbarButton;
var StyledPopoverList = (0, _context.styledWithTheme)('ul')(function (_ref9) {
  var selectors = _ref9.theme.selectors;
  return {
    listStyle: 'none',
    margin: 0,
    padding: "".concat((0, _utils.px)(selectors.space(_constants2.TABLE_POPOVER_LIST_PADDING_VERTICAL)), " ").concat((0, _utils.px)(selectors.space(_constants2.TABLE_POPOVER_LIST_PADDING_HORIZONTAL)))
  };
});
exports.StyledPopoverList = StyledPopoverList;
var StyledPopoverOptionSeparator = (0, _context.styledWithTheme)('li')(function (_ref10) {
  var selectors = _ref10.theme.selectors;
  return {
    height: (0, _utils.px)(_constants2.TABLE_POPOVER_SEPARATOR_HEIGHT),
    backgroundColor: selectors.color(_constants2.TABLE_POPOVER_SEPARATOR_COLOR),
    marginTop: (0, _utils.px)(_constants2.TABLE_POPOVER_SEPARATOR_MARGIN),
    marginBottom: (0, _utils.px)(_constants2.TABLE_POPOVER_SEPARATOR_MARGIN)
  };
});
exports.StyledPopoverOptionSeparator = StyledPopoverOptionSeparator;
var StyledPopoverItem = (0, _context.styledWithTheme)('li')(function (_ref11) {
  var _ref11$theme = _ref11.theme,
      selectors = _ref11$theme.selectors,
      isInHighContrast = _ref11$theme.isInHighContrast,
      disabled = _ref11.disabled,
      isHighlighted = _ref11.isHighlighted,
      isSelected = _ref11.isSelected;
  var padding = selectors.space(_constants2.TABLE_POPOVER_ITEM_PADDING);
  var highlightedStyles = {
    backgroundColor: selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR),
    outline: "".concat((0, _utils.px)(_constants2.TABLE_POPOVER_ITEM_OUTLINE_WIDTH), " ").concat(selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR), " solid"),
    outlineOffset: '1px'
  };
  var disabledStyles = {
    color: isInHighContrast ? _constants2.WHCM_DISABLED_ITEM_COLOR : (0, _utils.opacify)(selectors.color(_constants2.TABLE_POPOVER_ITEM_TEXT_COLOR), _constants2.TABLE_POPOVER_ITEM_DISABLED_TEXT_OPACITY)
  };
  var selectedStyles = {
    paddingLeft: (0, _utils.px)(padding * 2),
    '&:before': {
      display: 'block',
      content: '""',
      width: 5,
      height: '100%',
      backgroundColor: isInHighContrast ? 'CanvasText' : selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR),
      position: 'absolute',
      alignSelf: 'stretch',
      borderRadius: "".concat((0, _utils.px)(padding), " 0 0 ").concat((0, _utils.px)(padding)),
      top: 0,
      left: 0
    }
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    borderRadius: selectors.radius(_constants2.TABLE_POPOVER_ITEM_BORDER_RADIUS),
    width: '100%',
    alignItems: 'center',
    padding: padding,
    marginTop: (0, _utils.px)(padding / 2),
    marginBottom: (0, _utils.px)(padding / 2),
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: selectors.fontFamily('primary'),
    fontWeight: selectors.fontWeight('regular'),
    fontSize: selectors.fontSize(_constants2.TABLE_POPOVER_ITEM_FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants2.TABLE_POPOVER_ITEM_FONT_SIZE),
    backgroundColor: isSelected ? selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR) : selectors.color(_constants2.TABLE_POPOVER_ITEM_BACKGROUND_COLOR),
    position: 'relative',
    textAlign: 'left',
    transition: 'box-shadow .2s, border-color .2s',
    outline: 'none'
  }, isHighlighted ? highlightedStyles : {}), disabled ? disabledStyles : {
    color: selectors.color(_constants2.TABLE_POPOVER_ITEM_TEXT_COLOR)
  }), isSelected ? selectedStyles : {}), {}, {
    '&:not(:disabled):hover': {
      highlightedStyles: highlightedStyles
    },
    '&:first-child': {
      marginTop: 0
    },
    '&:last-child': {
      marginBottom: 0
    }
  });
});
exports.StyledPopoverItem = StyledPopoverItem;
var StyledColorItem = (0, _context.styledWithTheme)('li')(function (_ref12) {
  var _ref12$theme = _ref12.theme,
      selectors = _ref12$theme.selectors,
      isInHighContrast = _ref12$theme.isInHighContrast,
      isHighlighted = _ref12.isHighlighted,
      isSelected = _ref12.isSelected;
  var padding = selectors.space(_constants2.TABLE_POPOVER_ITEM_PADDING);
  var highlightedStyles = {
    backgroundColor: selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR),
    outline: "".concat((0, _utils.px)(_constants2.TABLE_POPOVER_ITEM_OUTLINE_WIDTH), " ").concat(selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR), " solid"),
    outlineOffset: '1px'
  };
  var selectedStyles = {
    paddingLeft: (0, _utils.px)(padding * 2),
    '&:before': {
      display: 'block',
      content: '""',
      width: 5,
      height: '100%',
      backgroundColor: isInHighContrast ? 'CanvasText' : selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_OUTLINE_COLOR),
      position: 'absolute',
      alignSelf: 'stretch',
      borderRadius: "".concat((0, _utils.px)(padding), " 0 0 ").concat((0, _utils.px)(padding)),
      top: 0,
      left: 0
    }
  };
  return _objectSpread(_objectSpread(_objectSpread({
    borderRadius: selectors.radius(_constants2.TABLE_POPOVER_ITEM_BORDER_RADIUS),
    width: '100%',
    alignItems: 'center',
    padding: padding,
    marginTop: (0, _utils.px)(padding / 2),
    marginBottom: (0, _utils.px)(padding / 2),
    border: 'none',
    cursor: 'pointer',
    fontFamily: selectors.fontFamily('primary'),
    fontWeight: selectors.fontWeight('regular'),
    fontSize: selectors.fontSize(_constants2.TABLE_POPOVER_ITEM_FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants2.TABLE_POPOVER_ITEM_FONT_SIZE),
    backgroundColor: isSelected ? selectors.color(_constants2.TABLE_POPOVER_ITEM_HIGHLIGHT_BACKGROUND_COLOR) : selectors.color(_constants2.TABLE_POPOVER_ITEM_BACKGROUND_COLOR),
    position: 'relative',
    textAlign: 'left',
    transition: 'box-shadow .2s, border-color .2s',
    outline: 'none'
  }, isHighlighted ? highlightedStyles : {}), isSelected ? selectedStyles : {}), {}, {
    '&:not(:disabled):hover': {
      highlightedStyles: highlightedStyles
    },
    '&:first-child': {
      marginTop: 0
    },
    '&:last-child': {
      marginBottom: 0
    }
  });
});
exports.StyledColorItem = StyledColorItem;
var StyledBadge = (0, _context.styledWithTheme)('span')(function (_ref13) {
  var selectors = _ref13.theme.selectors,
      colorCode = _ref13.colorCode;
  return {
    height: (0, _utils.px)(_constants2.COLOR_BADGE_HEIGHT),
    width: (0, _utils.px)(_constants2.COLOR_BADGE_WIDTH),
    alignItems: 'center',
    borderRadius: selectors.radius(_constants2.COLOR_POPOVER_BADGE_RADIUS),
    display: 'flex',
    padding: '0 2px 0 2px',
    marginRight: (0, _utils.px)(_constants2.COLOR_POPOVER_BADGE_MARGIN_RIGHT),
    backgroundColor: colorCode
  };
});
exports.StyledBadge = StyledBadge;
var StyledHighlightBadge = (0, _context.styledWithTheme)('span')(function (_ref14) {
  var selectors = _ref14.theme.selectors,
      colorCode = _ref14.colorCode;
  return {
    height: (0, _utils.px)(_constants2.COLOR_BADGE_HEIGHT),
    width: (0, _utils.px)(_constants2.COLOR_BADGE_WIDTH),
    alignItems: 'center',
    display: 'flex',
    padding: '0 2px 0 2px',
    borderColor: selectors.color('neutral20'),
    marginRight: (0, _utils.px)(_constants2.COLOR_POPOVER_BADGE_MARGIN_RIGHT),
    backgroundColor: colorCode,
    borderRadius: selectors.radius('R100')
  };
});
exports.StyledHighlightBadge = StyledHighlightBadge;
var StyledPopoverColorOptionContainer = (0, _context.styledWithTheme)('div')(function () {
  return {
    display: 'flex',
    alignItems: 'center',
    alignmentBaseline: 'central'
  };
});
exports.StyledPopoverColorOptionContainer = StyledPopoverColorOptionContainer;
var StyledPopoverColorOptionTextContainer = (0, _context.styledWithTheme)('div')(function (_ref15) {
  var selectors = _ref15.theme.selectors;
  return {
    cursor: 'default',
    color: selectors.color(_constants2.COLOR_POPOVER_TEXT_COLOR),
    fontFamily: selectors.fontFamily('primary'),
    fontWeight: selectors.fontWeight('regular'),
    padding: '4px 0 4px 0',
    lineHeight: selectors.lineHeight(_constants2.TABLE_POPOVER_ITEM_FONT_SIZE),
    marginLeft: (0, _utils.px)(10),
    marginRight: (0, _utils.px)(20),
    maxWidth: (0, _utils.px)(_constants2.COLOR_POPOVER_TEXT_WIDTH)
  };
});
exports.StyledPopoverColorOptionTextContainer = StyledPopoverColorOptionTextContainer;